export default {"src":"/_next/static/media/icone-profile.bf281545.svg","height":34,"width":28,"blurWidth":0,"blurHeight":0};